var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCbd = function SvgCbd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "-0.1 0 16.1 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.73 4.044a6.039 6.039 0 1 0 8.54 8.54 6.039 6.039 0 0 0-8.54-8.54m9.927-1.387A8 8 0 1 0 2.343 13.97 8 8 0 0 0 13.657 2.657"
  })));
};
export default SvgCbd;